// (function () {
//     'use strict';

//     // ReSharper disable once UndeclaredGlobalVariableUsing
//     const module = angular.module('imApp');

//     module.component('p2UpdateProcedures', {
//         templateUrl: 'views/components/views/p2UpdateProcedures/p2UpdateProcedures.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['stateService', 'utilityService', 'p2UpdateProceduresService', 'rememberService', 'layoutService', function (stateService, utilityService, p2UpdateProceduresService, rememberService, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let tabletSize = layoutService.getMediaQueries().tablet;
    		
//             let variableNames = {
//                 searchtext: ''
//             };

//             vm.model = {
//                 tabletSize: tabletSize,
//                 itemState: '',
//                 p2UpdateProcedureKeyno: '',
//                 searchTextButtons: [
//                     { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('searchtext') }
//                 ], 
//                 setting: {},
//                 itemsListUpdateProcedures: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALLS

//             let loadSetting = function () {
//                 p2UpdateProceduresService.getUpdateProcedure().then(function (info) {
//                     angular.copy(info[0], vm.model.setting);
//                 });
//             };

//             let loadUpdateProcedures = function () {
//                 p2UpdateProceduresService.listUpdateProcedures().then(function (list) {
//                     angular.copy(list, vm.model.itemsListUpdateProcedures);

//                     angular.forEach(vm.model.itemsListUpdateProcedures, function (item) {
//                         if (item.item_state > '') {
//                             vm.model.itemState = item.item_state;
//                         }
//                     });
//                 });
//             };

//             // #endregion LOAD PROCEDURE CALLS

//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             let rememberFunc = function (id) {
//                 angular.forEach(variableNames, function (_, key) {
//                     variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'searchtext':
//                         if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             };

// 		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region RESET BUTTON FUNCTION

//             let reset = function (id) {
//                 switch (id) {
//                     case 'searchtext':
//                         vm.model.setting.searchtext = '';

//                         if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                         break;
//                     default:
//                         break;
//                 };
//             };

// 		    // #endregion RESET BUTTON FUNCTION

//             // #region UPDATE PROCEDURE LIST FUNCTION

//             vm.updateList = function () {
//                 loadUpdateProcedures();
//             };

//             // #endregion UPDATE PROCEDURE LIST FUNCTION

//             // #region LIST DIRECTION BUTTON FUNCTION

//             vm.openEdit = function (item) {
//                 vm.model.p2UpdateProcedureKeyno = item.item_id;
//             };

//             // #endregion LIST DIRECTION BUTTON FUNCTION

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 let go = function (parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 };

//                 switch (state) {
//                     case 'p2updateprocedureedit':
//                         if (tabletSize.matches === true && vm.model.itemState === 'p2updateprocedureedit') {
//                             vm.model.p2UpdateProcedureKeyno = '0';
//                         } else {
//                             go({ p2_updateprocedure_keyno: '0' });
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

// 		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onBlur = function (id) {
//                 switch (id) {
//                     case 'searchtext':
//                         if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                         break;
//                     default:
//                         break;
//                 };
//             };

// 		    // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'searchtext':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                         vm.model.setting.searchtext = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                         if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadSetting();
//                 loadUpdateProcedures();
//             };

// 		    // #endregion ON INIT FUNCTION
//         }]
//     });
// })();
